import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies
import styles from './pageContainer.module.css';
import './global.css';
import Navbar from '../components/navbar';
import MobileMenu from '../components/navbar/mobileMenu';

const outerContainerStyle = {
  // overflow: 'hidden',
};

export default ({ children }) => ( // eslint-disable-line react/prop-types
  <div id="outer-container" style={outerContainerStyle}>
    <Navbar key="navbar" />
    <div key="mobileMenu" className={styles.mobileMenu}>
      <MobileMenu />
    </div>
    <div key="pageContent" id="page-wrap" className={styles.contentContainer}>
      {children()}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/layouts/index.jsx